module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-wrapper"
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b7711928","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-wrapper/view-wrapper.vue
// module id = 619
// module chunks = 0